/* eslint-disable no-script-url,jsx-a11y/anchor-is-valid */
import React from "react";
import SVG from "react-inlinesvg";
import {Dropdown,Button} from "react-bootstrap";
import {toAbsoluteUrl} from "../../../_helpers";
import {DropdownCustomToggler, DashboardUserMenu} from "../../dropdowns";
import {DashboardRoomMenu} from "../../dropdowns/DashboardRoomMenu";
import {Link} from "react-router-dom";
import {useTranslation} from "react-i18next";

export function DashboardRoomsList({ className,rooms=[],onDelete }) {
	const { t } = useTranslation('common')
	return (
		<>
			<div className={`card card-custom ${className}`}>
				{/* Head */}
				<div className="card-header border-0">
					<h3 className="card-title font-weight-bolder text-dark">{t('LatestRooms')}</h3>
					<div className="card-toolbar">
						<Link to={'/room/new'}><Button variant="outline-primary">{t('MENU.NEW')}</Button></Link>
					</div>
				</div>
				{/* Body */}
				<div className="card-body pt-2">
					{rooms.map((room,index)=>
						<div key={index} className="d-flex align-items-center mb-10">
							<div className="symbol symbol-40 symbol-light-success mr-5">
              <span className="symbol-label">
                <SVG
									className="h-100 align-self-end"
									src={toAbsoluteUrl("/media/svg/icons/Home/Commode1.svg")}
								/>
              </span>
							</div>
							<div className="d-flex flex-column flex-grow-1 font-weight-bold">
								<a
									href="#"
									className="text-dark text-hover-primary mb-1 font-size-lg"
								>
									{room.name}
								</a>
								<span className="text-muted">#{room.id}</span>
							</div>
							<ItemDropdown item={room} onDelete={()=>onDelete(room.id)} />
						</div>
					)}
				</div>
			</div>
		</>
	);
}

const ItemDropdown = ({item,onDelete}) => {
	return (<>
		<Dropdown className="dropdown-inline" alignRight>
			<Dropdown.Toggle
				id="dropdown-toggle-top"
				as={DropdownCustomToggler}>
				<i className="ki ki-bold-more-hor" />
			</Dropdown.Toggle>
			<Dropdown.Menu className="dropdown-menu dropdown-menu-sm dropdown-menu-right">
				<DashboardRoomMenu item={item} onDelete={onDelete}/>
			</Dropdown.Menu>
		</Dropdown>
	</>);
};
